// extracted by mini-css-extract-plugin
export default {"homepage_wrapper":"homepage_homepage_wrapper__v4b18","homepage_mobile":"homepage_homepage_mobile__7V8+8"};